import React, { useEffect, useState, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { observer } from 'mobx-react';
import { Button } from '@mui/material';
import { styled } from '@mui/system';
import { isEmpty } from 'lodash';

import './index.scss';
import Color from '@tool/color';
import { CloseIcon20 } from '@styled/icon';
import moCompanyScale from './store';
import Scale from './scale';
import Property from './property';
import moScale from './store';
import Empty from '@comp/empty/index';

interface IProps {}
interface IState {}

const CompanyScale = (props: IProps, state: IState) => {
  const navi = useNavigate();
  const { companyScale, companyProperty } = moScale;

  useEffect(() => {
    return () => {};
  }, []);

  return (
    <section className="company-scale_10">
      <section className="section-166">
        <strong className="sub-11">公司规模分布</strong>
        {!isEmpty(companyScale) ? (
          <section className="section-167">
            <Scale title="hello" list={[]} />
          </section>
        ) : <Empty padding="60px 0" />}
      </section>

      <section className="section-166">
        <strong className="sub-11">公司性质分布</strong>
        {!isEmpty(companyProperty) ? (
          <section className="section-167">
            <Property title="hello" list={[]} />
          </section>
        ) : <Empty padding="60px 0" />}
      </section>
    </section>
  );
};

export default observer(CompanyScale);
